import { render, staticRenderFns } from "./RegulatoryUpdateAnnouncementPJ.vue?vue&type=template&id=3306b0e2&scoped=true&"
import script from "./RegulatoryUpdateAnnouncementPJ.vue?vue&type=script&lang=ts&"
export * from "./RegulatoryUpdateAnnouncementPJ.vue?vue&type=script&lang=ts&"
import style0 from "./RegulatoryUpdateAnnouncementPJ.vue?vue&type=style&index=0&id=3306b0e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3306b0e2",
  null
  
)

export default component.exports